<template>
  <div>
    <PageHeader>
      <template v-slot:header>{{ humanPowerTitle }}</template>
    </PageHeader>

    <v-row>
      <v-col cols="3" class="pt-0 pb-0 pl-3 pr-2">
        <FormInputComponent
          label="タイトル"
          type="string"
          v-model="humanPowerTitle"
          rules="required"
        />
      </v-col>
      <v-col cols="9" class="pt-4 pb-0 pl-0 pr-0">
        <p>
          <span style="margin-right: 15px">ウェイト合計</span>&nbsp;
          <strong style="color: red">{{ totalWeight }}</strong
          >&nbsp;／&nbsp;
          <strong>{{ currentWeight }}</strong>
          <span v-if="totalWeight != currentWeight" style="margin-left: 20px"
            ><strong style="color: red"
              >※合計点数が一致していません。</strong
            ></span
          >
          <span v-if="totalWeight == currentWeight" style="margin-left: 20px"
            ><strong style="color: blue"
              >※合計点数が一致しています。</strong
            ></span
          >
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="humanPowerTitle != humanPowerTitleInit"
        cols="3"
        xs="4"
        class="pt-0 pb-3 pl-3 pr-0"
      >
        <Button @click="change_confirm()" color="primary">タイトル更新</Button>
      </v-col>
      <v-col cols="2" xs="4" class="pt-0 pb-3 pl-3 pr-0">
        <Button v-if="isEdit" @click="edit()" color="info">新規追加</Button>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0 pb-0 pl-3 pr-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="-1"
          hide-default-footer
          group-by="ACT_EMT_NAME"
          group-desc:true
          @click:row="edit"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="行動内容は見つかりませんでした。新規追加ボタンより行動内容を設定してください。"
        >
          <template v-slot:[`item.ACT_EMT_CONTENT`]="{ item }">
            <p
              style="padding: 16px 5px 0px 0px"
              v-html="item.ACT_EMT_CONTENT"
            ></p>
          </template>
          <template
            #[`group.header`]="{ group, items, headers, toggle, isOpen }"
          >
            <td colspan="2">
              <v-btn @click="toggle" x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-minus</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
              </v-btn>
              {{ group }}
            </td>
            <td align="right">{{ getTotal(items) }}</td>
            <td :colspan="headers.length"></td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <ConfirmDialog
      ref="confirm"
      :title="humanPowerTitleMsg"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="changeEvaluationInfo"
    >
    </ConfirmDialog>

    <DialogMessage ref="dialog" />
    <ActionDetailEdit
      ref="edit"
      @edit="editEvaluationInfo"
      @closeEdit="closeEdit"
    />
  </div>
</template>

<script>
import ActionDetailEdit from './StaffActionDetailEdit.vue';
import message from '../../../message.js';
import axios from 'axios';
import config from '../../../const.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem } from '../../../common.js';

export default {
  components: {
    ActionDetailEdit,
    ConfirmDialog,
  },
  props: {
    goalId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    periodStatus: {
      type: [String, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      confirm: false,
      totalWeight: 0,
      currentWeight: 0,
      humanPowerTitle: '',
      humanPowerTitleInit: '',
      humanPowerTitleMsg: '',
      evalStatus: '',
      isEdit: false,
      confirmMessage: null,
      userInfo: {},
      items: [],
      headers: [
        {
          text: '表示順',
          align: 'left',
          value: 'ORDER',
          groupable: false,
          width: '10%',
        },
        {
          text: '行動内容',
          align: 'left',
          value: 'ACT_EMT_CONTENT',
          groupable: false,
          width: '80%',
        },
        {
          text: 'ウェイト',
          align: 'right',
          value: 'ACT_EMT_WEIGHT',
          groupable: false,
          width: '10%',
        },
        {
          text: '行動要素',
          align: 'right',
          value: 'ACT_EMT_NAME',
          isOpen: true,
        },
      ],
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;

    this.getEvaluationItems();
  },
  methods: {
    editEvaluationInfo() {
      // 評価情報取得
      this.getEvaluationItems();
    },
    closeEdit() {
      // 評価情報取得
      this.getEvaluationItems();
    },
    change_confirm() {
      // タイトル
      if (!this.humanPowerTitle) {
        this.$refs.dialog.open(
          'info',
          'タイトルが未入力です。タイトルを入力してください。'
        );
        return;
      }
      // 確認ダイアログ表示
      this.confirmMessage = this.humanPowerTitle + 'の情報を変更しますか？';
      this.$refs.confirm.open();
    },
    changeEvaluationInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      // 行動内容その他情報更新
      this.changeActionOtherInfoRequest();
    },
    changeActionOtherInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 行動内容その他情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/action/other/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            USER_ID: this.userId,
            HUMAN_POWER_TITLE: this.humanPowerTitle,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            this.humanPowerTitleInit = this.humanPowerTitle;
            this.humanPowerTitleMsg =
              this.humanPowerTitle + config.MESSAGE_EDIT;
            msgStr = this.humanPowerTitle + 'の更新が成功しました。';
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    async edit(item) {
      // 編集OKの場合のみ処理を行う(Hitonobi改善で修正)
      /*
      if (!this.isEdit) {
        return;
      }
      */

      var updateFlg = false;
      var groupId = 0;
      var actEmtId = '';
      var actEmtName = '';
      var actEmtContent1 = '';
      var actEmtContent2 = '';
      var actEmtWeight1 = 0;
      var actEmtWeight2 = 0;

      if (item != null) {
        updateFlg = true;
        groupId = item.GROUP_ID;
        actEmtId = item.ACT_EMT_ID;
        actEmtName = item.ACT_EMT_NAME.replace(
          groupId + config.ACT_EMT_NAME_ADD_STR,
          ''
        );
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].GROUP_ID == groupId) {
            if (this.items[i].ORDER == 1) {
              actEmtContent1 = this.items[i].ACT_EMT_CONTENT;
              actEmtWeight1 = this.items[i].ACT_EMT_WEIGHT;
            } else {
              actEmtContent2 = this.items[i].ACT_EMT_CONTENT;
              actEmtWeight2 = this.items[i].ACT_EMT_WEIGHT;
            }
          }
        }
      } else {
        if (this.items.length >= 12) {
          // 行動要素が6つ入力されている場合は処理終了
          this.$refs.dialog.open('info', message.MSG_INFO_ACT_ENTRY_NG);
          return;
        }
        updateFlg = false;
        var isElement1 = true;
        var isElement2 = true;
        var isElement3 = true;
        var isElement4 = true;
        var isElement5 = true;
        var isElement6 = true;

        // 行動要素1の存在チェック
        for (var cnt1 = 0; cnt1 < this.items.length; cnt1++) {
          if (this.items[cnt1].GROUP_ID == 1) {
            isElement1 = false;
          }
        }
        // 行動要素2の存在チェック
        for (var cnt2 = 0; cnt2 < this.items.length; cnt2++) {
          if (this.items[cnt2].GROUP_ID == 2) {
            isElement2 = false;
          }
        }
        // 行動要素3の存在チェック
        for (var cnt3 = 0; cnt3 < this.items.length; cnt3++) {
          if (this.items[cnt3].GROUP_ID == 3) {
            isElement3 = false;
          }
        }
        // 行動要素4の存在チェック
        for (var cnt4 = 0; cnt4 < this.items.length; cnt4++) {
          if (this.items[cnt4].GROUP_ID == 4) {
            isElement4 = false;
          }
        }
        // 行動要素5の存在チェック
        for (var cnt5 = 0; cnt5 < this.items.length; cnt5++) {
          if (this.items[cnt5].GROUP_ID == 5) {
            isElement5 = false;
          }
        }
        // 行動要素6の存在チェック
        for (var cnt6 = 0; cnt6 < this.items.length; cnt6++) {
          if (this.items[cnt6].GROUP_ID == 6) {
            isElement5 = false;
          }
        }
        // GROUP_IDの決定
        if (isElement1) {
          groupId = 1;
        } else if (isElement2) {
          groupId = 2;
        } else if (isElement3) {
          groupId = 3;
        } else if (isElement4) {
          groupId = 4;
        } else if (isElement5) {
          groupId = 5;
        } else if (isElement6) {
          groupId = 6;
        }
      }

      // 編集ダイアログ表示
      this.$refs.edit.open(
        this.goalId,
        this.userId,
        groupId,
        actEmtId,
        actEmtName,
        actEmtContent1,
        actEmtContent2,
        actEmtWeight1,
        actEmtWeight2,
        updateFlg,
        this.isEdit,
        this.humanPowerTitle
      );

      /*
      // ローディング画像表示
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalId +
            '/' +
            this.userId
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            if (response.data[0].GOAL_EDIT_FLG != config.EDIT_OK) {
              // 目標編集フラグが[0:編集許可 ]で、且つ、評価確定以外の場合に編集許可
              this.$refs.dialog.open(
                'info',
                '初回の自己評価が完了しているため、目標の更新はできません。\n' +
                  ' 自己評価者、一次評価者とご相談をお願いします。'
              );
              return;
            } else {
              // 編集ダイアログ表示
              this.$refs.edit.open(
                this.goalId,
                this.userId,
                groupId,
                actEmtId,
                actEmtName,
                actEmtContent1,
                actEmtContent2,
                actEmtWeight1,
                actEmtWeight2,
                updateFlg,
                this.humanPowerTitle
              );
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
        */
    },
    async getEvaluationItems() {
      this.loading = true;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalId +
            '/' +
            this.userId
        )
        .then((response) => {
          // 人間力タイトル
          this.humanPowerTitle = response.data[0].HUMAN_POWER_TITLE;
          this.humanPowerTitleInit = this.humanPowerTitle;
          this.humanPowerTitleMsg = this.humanPowerTitle + config.MESSAGE_EDIT;
          this.currentWeight = Number(response.data[0].HUMAN_POWER_RATE);
          this.totalWeight = 0;

          // 状態
          this.evalStatus = response.data[0].EVAL_STATUS;
          // 活性制御
          /*
          if (response.data[0].GOAL_EDIT_FLG == config.EDIT_OK) {
            // 編集許可
            this.isEdit = true;
          } else {
            // 編集不可
            this.isEdit = false;
          }
          */
          this.isEdit = false; // 初期状態:編集不可
          if (
            response.data[0].GOAL_EDIT_FLG == config.EDIT_OK &&
            this.periodStatus != config.PERIOD_STATUS_EVAL_COMPLETE
          ) {
            // 目標編集フラグが[0:編集許可 ]で、且つ、評価確定以外の場合に編集許可
            this.isEdit = true;
          }

          this.items = [];

          // 目標データ取得
          if (response.data[0].ACT_EMT_1_ID != config.GOAL_EMPTY_STRING) {
            // 行動要素1-1
            if (
              response.data[0].ACT_EMT_1_CONTENT1 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt1_1 = {
                GROUP_ID: 1,
                ORDER: 1,
                ACT_EMT_ID: response.data[0].ACT_EMT_1_ID,
                ACT_EMT_NAME:
                  1 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_1_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_1_CONTENT1,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_1_WEIGHT1),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_1_WEIGHT1);
              this.items.push(actEmt1_1);
            }
            // 行動要素1-2
            if (
              response.data[0].ACT_EMT_1_CONTENT2 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt1_2 = {
                GROUP_ID: 1,
                ORDER: 2,
                ACT_EMT_ID: response.data[0].ACT_EMT_1_ID,
                ACT_EMT_NAME:
                  1 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_1_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_1_CONTENT2,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_1_WEIGHT2),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_1_WEIGHT2);
              this.items.push(actEmt1_2);
            }
          }

          if (response.data[0].ACT_EMT_2_ID != config.GOAL_EMPTY_STRING) {
            // 行動要素2-1
            if (
              response.data[0].ACT_EMT_2_CONTENT1 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt2_1 = {
                GROUP_ID: 2,
                ORDER: 1,
                ACT_EMT_ID: response.data[0].ACT_EMT_2_ID,
                ACT_EMT_NAME:
                  2 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_2_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_2_CONTENT1,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_2_WEIGHT1),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_2_WEIGHT1);
              this.items.push(actEmt2_1);
            }
            // 行動要素2-2
            if (
              response.data[0].ACT_EMT_2_CONTENT2 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt2_2 = {
                GROUP_ID: 2,
                ORDER: 2,
                ACT_EMT_ID: response.data[0].ACT_EMT_2_ID,
                ACT_EMT_NAME:
                  2 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_2_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_2_CONTENT2,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_2_WEIGHT2),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_2_WEIGHT2);
              this.items.push(actEmt2_2);
            }
          }

          if (response.data[0].ACT_EMT_3_ID != config.GOAL_EMPTY_STRING) {
            // 行動要素3-1
            if (
              response.data[0].ACT_EMT_3_CONTENT1 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt3_1 = {
                GROUP_ID: 3,
                ORDER: 1,
                ACT_EMT_ID: response.data[0].ACT_EMT_3_ID,
                ACT_EMT_NAME:
                  3 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_3_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_3_CONTENT1,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_3_WEIGHT1),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_3_WEIGHT1);
              this.items.push(actEmt3_1);
            }
            // 行動要素3-2
            if (
              response.data[0].ACT_EMT_3_CONTENT2 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt3_2 = {
                GROUP_ID: 3,
                ORDER: 2,
                ACT_EMT_ID: response.data[0].ACT_EMT_3_ID,
                ACT_EMT_NAME:
                  3 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_3_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_3_CONTENT2,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_3_WEIGHT2),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_3_WEIGHT2);
              this.items.push(actEmt3_2);
            }
          }

          if (response.data[0].ACT_EMT_4_ID != config.GOAL_EMPTY_STRING) {
            // 行動要素4-1
            if (
              response.data[0].ACT_EMT_4_CONTENT1 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt4_1 = {
                GROUP_ID: 4,
                ORDER: 1,
                ACT_EMT_ID: response.data[0].ACT_EMT_4_ID,
                ACT_EMT_NAME:
                  4 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_4_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_4_CONTENT1,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_4_WEIGHT1),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_4_WEIGHT1);
              this.items.push(actEmt4_1);
            }
            // 行動要素4-2
            if (
              response.data[0].ACT_EMT_4_CONTENT2 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt4_2 = {
                GROUP_ID: 4,
                ORDER: 2,
                ACT_EMT_ID: response.data[0].ACT_EMT_4_ID,
                ACT_EMT_NAME:
                  4 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_4_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_4_CONTENT2,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_4_WEIGHT2),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_4_WEIGHT2);
              this.items.push(actEmt4_2);
            }
          }

          if (response.data[0].ACT_EMT_5_ID != config.GOAL_EMPTY_STRING) {
            // 行動要素5-1
            if (
              response.data[0].ACT_EMT_5_CONTENT1 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt5_1 = {
                GROUP_ID: 5,
                ORDER: 1,
                ACT_EMT_ID: response.data[0].ACT_EMT_5_ID,
                ACT_EMT_NAME:
                  5 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_5_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_5_CONTENT1,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_5_WEIGHT1),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_5_WEIGHT1);
              this.items.push(actEmt5_1);
            }
            // 行動要素5-2
            if (
              response.data[0].ACT_EMT_5_CONTENT2 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt5_2 = {
                GROUP_ID: 5,
                ORDER: 2,
                ACT_EMT_ID: response.data[0].ACT_EMT_5_ID,
                ACT_EMT_NAME:
                  5 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_5_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_5_CONTENT2,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_5_WEIGHT2),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_5_WEIGHT2);
              this.items.push(actEmt5_2);
            }
          }

          if (response.data[0].ACT_EMT_6_ID != config.GOAL_EMPTY_STRING) {
            // 行動要素6-1
            if (
              response.data[0].ACT_EMT_6_CONTENT1 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt6_1 = {
                GROUP_ID: 6,
                ORDER: 1,
                ACT_EMT_ID: response.data[0].ACT_EMT_6_ID,
                ACT_EMT_NAME:
                  6 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_6_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_6_CONTENT1,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_6_WEIGHT1),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_6_WEIGHT1);
              this.items.push(actEmt6_1);
            }
            // 行動要素6-2
            if (
              response.data[0].ACT_EMT_6_CONTENT2 != config.GOAL_EMPTY_STRING
            ) {
              var actEmt6_2 = {
                GROUP_ID: 6,
                ORDER: 2,
                ACT_EMT_ID: response.data[0].ACT_EMT_6_ID,
                ACT_EMT_NAME:
                  6 +
                  config.ACT_EMT_NAME_ADD_STR +
                  response.data[0].ACT_EMT_6_NAME,
                ACT_EMT_CONTENT: response.data[0].ACT_EMT_6_CONTENT2,
                ACT_EMT_WEIGHT: Number(response.data[0].ACT_EMT_6_WEIGHT2),
              };
              this.totalWeight =
                this.totalWeight + Number(response.data[0].ACT_EMT_6_WEIGHT2);
              this.items.push(actEmt6_2);
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
    getTotal(items) {
      let total = 0;
      total = items.reduce((prev, current) => {
        return prev + current.ACT_EMT_WEIGHT;
      }, 0);
      return total;
    },
  },
};
</script>
<style>
.centered-input input {
  text-align: center;
}
</style>
